import React from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';

class LzDimmer extends React.Component {

    onClick() {
        if (this.props.onClick) {
            this.props.onClick();
        }
    }

    render() {
        const { active, style, onClick, children } = this.props;

        const styles = style || {};
        if (!styles.zIndex) {
            styles.zIndex = 999;
        }
        if (!styles.color) {
            styles.color = '#fff';
        }
        if (onClick && !styles.cursor) {
            styles.cursor = 'pointer';
        }

        return (
            <Backdrop
                style={styles}
                open={active}
                onClick={() => this.onClick()}
            >
                <CircularProgress color="inherit" />
                {children}
            </Backdrop>
        );
    }

}

export default LzDimmer;
